import React from 'react';
import { DialogProps } from '@material-ui/core/Dialog';
import YourInControl from '../../../../assets/tutorial-graphics/welcome/youre_in_control.png';
import { TutorialDialog, TutorialDialogStep } from '../../../../common/dialogs/TutorialDialog';

const steps: Array<TutorialDialogStep> = [
  {
    label: 'Calendar View',
    description: (
      <>
        The <strong>Calendar View</strong> gives you a visual overview of all your activities and their roster status.
        <br />
        <br />
        Activities are color-coded based on their roster status: red for unpublished rosters, orange for understaffed
        activities, and green for fully rostered activities.
      </>
    ),
    image: YourInControl,
  },
  {
    label: 'Quick Roster Access',
    description: (
      <>
        <strong>Click on any activity</strong> in the calendar to quickly access its roster management.
        <br />
        <br />
        This provides a fast way to navigate directly to activities that need attention without browsing through lists.
      </>
    ),
    image: YourInControl,
  },
  {
    label: 'Calendar Navigation',
    description: (
      <>
        Use the calendar controls to switch between <strong>day, week, and month views</strong> to get different levels
        of detail.
        <br />
        <br />
        The calendar automatically loads roster data as you navigate between different date ranges.
      </>
    ),
    image: YourInControl,
  },
];

const CalendarRosterTutorialDialog = (props: DialogProps) => {
  const { open, onClose } = props;
  return <TutorialDialog open={open} onClose={onClose} steps={steps} />;
};

export { CalendarRosterTutorialDialog };
